import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import './world-map';

// More on default export: https://storybook.js.org/docs/web-components/writing-stories/introduction#default-export
export default {
  title: 'gsmlg/d3-geo/world-map',
  // More on argTypes: https://storybook.js.org/docs/web-components/api/argtypes
  argTypes: {},
} as Meta;

export interface ElementProps {
  width: string;
  height: string;
  centerLongitude: number;
  countryColor: string;
  borderColor: string;
  oceanColor: string;
  pointColor: string;
  points: [number, number][];
  pointRadius: number;
  pointAnimate: boolean;
  lines: [[number, number], [number, number]][];
  lineStrokeWidth: number;
  lineStroke: string;
  lineDashOffset: number;
  lineDashAnimate: number;
}

// More on component templates: https://storybook.js.org/docs/web-components/writing-stories/introduction#using-args
const Template: Story<ElementProps> = ({
  width,
  height,
  centerLongitude,
  countryColor,
  borderColor,
  oceanColor,
  pointColor,
  points,
  pointRadius,
  pointAnimate,
  lines,
  lineStroke,
  lineStrokeWidth,
  lineDashOffset,
  lineDashAnimate,
}) =>
  html`<div style="width: ${width}; height: ${height};">
    <d3-world-map
      center-longitude=${centerLongitude}
      country-color=${countryColor}
      border-color=${borderColor}
      ocean-color=${oceanColor}
      point-color=${pointColor}
      points=${JSON.stringify(points)}
      point-radius=${pointRadius}
      ?point-animate=${pointAnimate}
      lines=${JSON.stringify(lines)}
      line-stroke=${lineStroke}
      line-stroke-width=${lineStrokeWidth}
      line-dash-offset=${lineDashOffset}
      line-dash-animate=${lineDashAnimate}
    ></d3-world-map>
  </div>`;

export const WorldEqual = Template.bind({});

WorldEqual.args = {
  width: '800px',
  height: '500px',
  centerLongitude: 0,
  countryColor: '#b7a833',
  borderColor: '#c5e94d',
  oceanColor: '#1a2b9f',
  pointColor: '#bc2a3c',
  points: [[113.722, 34.7732]],
  pointRadius: 5,
  pointAnimate: true,
  lines: [
    [
      [-74.006, 40.7128],
      [0.1276, 51.5072],
    ],
    [
      [0.1276, 51.5072],
      [114.1694, 22.3193],
    ],
  ],
  lineStrokeWidth: Math.E * Math.LN2,
  lineStroke: '#ec2b57',
  lineDashOffset: 15,
  lineDashAnimate: 1500,
};
